import Buttons from '@/component/popups/Buttons';
import PopupFrame from '@/component/popups/ui-1';
import imgDontLoseYourStreak from '@assets/web-v3-images/icon-success.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export default function Successfully({
	open,
	onOpenChange,
	text = ''
}
) {
	const { t } = useTranslation()
	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={t("daily_reward.successfully")}
			classNames='sm:!max-w-[600px]'
		>
			<div className=" flex flex-col items-center justify-center">

				<div className="flex justify-center px-10 sm:px-15 md:px-30 lg:px-30 xl:px-35 pt-5">
					<img
						src={imgDontLoseYourStreak}
						alt="turns"
						className="w-[120px] sm:w-[160px] md:w-[220px] lg:w-[220px] xl:w-[220px] h-auto"
					/>
				</div>
				<Text
					as="p"
					className="text-[#A15C07] font-medium text-[13px] sm:text-[19px] text-center pt-6 sm:px-5"
				>
					{text}
				</Text>

				<div className="flex gap-3 justify-between pt-5 px-10 sm:px-20">
					<Buttons
						handleClick={() => onOpenChange(false)}
						textBtn={t("daily_reward.ok")}
						classItem="!m-0"
						classItemText='!text-[14px] sm:!text-[20px]'
					/>
				</div>
			</div>
		</PopupFrame>
	)
}
